import { fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

export const nameFilterSchema = z.object({
  name: fallback(z.string(), "").default(""),
});
